import clsx from 'clsx';

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={clsx('animate-pulse rounded-control bg-surface-raised', className)}
      aria-hidden="true"
    />
  );
}

/** FE-2-11 — per-card skeletons, so the dashboard fills in rather than blocking. */
export function CardSkeleton({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div className={clsx('card p-5', className)}>
      <Skeleton className="mb-4 h-3.5 w-28" />
      <div className="space-y-2.5">
        {Array.from({ length: lines }).map((_, i) => (
          <Skeleton key={i} className={clsx('h-3.5', i === lines - 1 ? 'w-2/3' : 'w-full')} />
        ))}
      </div>
    </div>
  );
}

export function FullPageSpinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas">
      {/* aria-live so a screen reader announces the wait rather than reading silence. */}
      <div className="flex flex-col items-center gap-3" role="status" aria-live="polite">
        <div className="h-7 w-7 animate-spin rounded-full border-2 border-line border-t-accent" />
        <p className="text-sm text-muted">{label}</p>
      </div>
    </div>
  );
}
